<template>
  <el-drawer
    :visible.sync="Visible"
    size="70%"
    title="Auditoria Tarjeta"
    @close="$emit('VisibleFalse')"
  >
    <br />
    <br />
    <rabbey-table-3
      :loading="Loading"
      :data="tableData"
      :columns="columns"
      :paginateFromApi="true"
      :paginationApi="{
        currentPage: paginaActual,
        pageSize: totalDeRegistrosPorPagina,
        total: registrosTotal
      }"
      @update-page-size="handleSizeChange"
      @update-current-page="handleCurrentChange"
      :class-table="{
        'table-box': true,
        'card-base': true,
        'card-shadow--medium': false
      }"
    />
  </el-drawer>
</template>

<script>
import { auditoriaColumns } from "./columnsTables/CardAuditoriaColumns";

export default {
  props: {
    tarjeta: String,
    cliente: Number,
    proveedor: Number,
    Visible: Boolean
  },

  data() {
    return {
      columns: auditoriaColumns,
      Loading: false,
      currentPage2: 1,
      totalDeRegistrosPorPagina: 10,
      paginaActual: 1,
      registrosTotal: 0,
      tableData: []
    };
  },

  methods: {
    handleSizeChange(val) {
      this.totalDeRegistrosPorPagina = val;
      this.GetData();
    },
    handleCurrentChange(val) {
      this.paginaActual = val;

      this.currentPage2 = this.paginaActual;
      this.GetData();
    },
    format(price) {
      return new Intl.NumberFormat("en-US").format(price);
    },
    ChangeDays() {
      this.paginaActual = 1;
      this.currentPage2 = this.paginaActual;
      this.GetData();
    },
    async GetData() {
      this.Loading = true;

      await this.$http
        .get(`/api/tennos/GetCardAuditoriaReport/`, {
          params: {
            TarjetaId: this.tarjeta,
            Clienteid: this.cliente,
            Proveedorid: this.proveedor
          }
        })
        .then((resp) => {
          this.registrosTotal = resp.data.total;
          this.tableData = resp.data.auditoria;
          this.Loading = false;
        });
    }
  },

  watch: {
    Visible(val) {
      if (val) {
        this.GetData();
      } else {
        this.tableData = [];
      }
    }
  }
};
</script>

<style scoped>
.el-table td {
  width: 10px;
}
.cell {
  width: 1px;
}
.Table {
  margin: 0 auto;
  padding-left: 200px;
}
.Pagination {
  margin: 0 auto;
}
</style>
